"use client";

import { Share2 } from "lucide-react";
import { SignUpButtonCTA } from "modules/auth/components/SignUpButtonCTA";
import { SignedIn, SignedOut } from "modules/auth/components/ClientAuthGate";
import { useReferralInviteStore } from "modules/city/stores/useReferralInviteStore";

interface CityInviteButtonProps {
  cityUrl: string;
  cityName: string;
}

export function CityInviteButton({ cityUrl, cityName }: CityInviteButtonProps) {
  const openModal = useReferralInviteStore((state) => state.openModal);
  const open = () => openModal({ context: "locked", cityUrl, cityName });

  return (
    <>
      <SignedOut>
        <div className="flex items-center gap-3">
          <SignUpButtonCTA>Get Started</SignUpButtonCTA>
          <button
            className="btn btn-outline btn-primary gap-2"
            aria-haspopup="dialog"
            onClick={open}
          >
            <Share2 size={18} />
            Share Link
          </button>
        </div>
      </SignedOut>

      <SignedIn>
        <button
          className="btn btn-primary gap-2"
          aria-haspopup="dialog"
          onClick={open}
        >
          <Share2 size={18} />
          Invite Traders
        </button>
      </SignedIn>
    </>
  );
}
